// Data for the gallery select tags.
// eslint-disable-next-line import/prefer-default-export
export const GalleryTags = [
  { label: 'África', value: 'africa' },
  { label: 'América Central', value: 'centralamerica' },
  { label: 'América del Norte', value: 'northamerica' },
  { label: 'América del Sur', value: 'southamerica' },
  { label: 'Asia', value: 'asia' },
  { label: 'Canadá', value: 'canada' },
  { label: 'Caribe', value: 'caribe' },
  { label: 'Europa', value: 'europe' },
  { label: 'México', value: 'mexico' },
  { label: 'Oceanía', value: 'oceania' },
];
